import { render, staticRenderFns } from "./Lang1Age4.vue?vue&type=template&id=0bf96055&scoped=true&"
import script from "./Lang1Age4.vue?vue&type=script&lang=js&"
export * from "./Lang1Age4.vue?vue&type=script&lang=js&"
import style0 from "./Lang1Age4.vue?vue&type=style&index=0&id=0bf96055&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf96055",
  null
  
)

export default component.exports